export const API_ENDPOINTS = {
  BASKET: '/basket',
  BASKET_PROCEED_PAYMENT: '/basket/proceed-payment',
  BASKET_TRANSPORT: '/basket/transport',

  PRICING: '/pricing',
  PRICING_ITEM: '/pricing-item',
  MY_BILLS: '/my-bills',
  BILLS: '/bills',
  DOCUMENT: '/document',
  SIRENE_URL: '/sirene/search',
  THEME: '/theme',
  NOTIFICATION: '/notification/get',
  CLOSE_NOTIFICATION: '/notification/close/',

  DOWNLOAD_BILLS_PDF: (basketOrderId: number) => `/bills/pdf/${basketOrderId}`,
  BROWSER_BILLS_PDF: (basketOrderId: number) => `/bills/browserPdf/${basketOrderId}`,
  EXTRACT_BILLS_DATA: (startDate: string, endDate: string, type: string, format: string) =>
    `/bills/extract?startDate=${startDate}&endDate=${endDate}&typeExport=${type}&formatExport=${format}`,

  COMMITMENT_ACCEPTANCE: () => `/customer/current/acceptCommitment`, // PUBLIC

  BASKET_TRANSPORT_ID: (transportId?: number) => `/basket/transport/${transportId}`,
  BASKET_ORDER: '/basket-order',
  BASKET_ORDER_TRANSPORT_ORDER_BILLS: `/basket-order/transport-order-bills`,
  BASKET_ORDER_REFUND: '/basket-order/refund/',
  BASKET_ORDER_BILLS_NO_PAID: (customerId?: number) => `/basket-order/customer/${customerId}/billsNoPaid`,
  TRANSPORT_ORDER_MODIFICATIONS: '/transport-order-modifications',
  TRANSPORT_ORDER_MODIFICATIONS_CAUSE: '/transport-order-modification-causes',

  DOCUMENT_GENERATE_STICKER: `/document/generate/STICKER`,
  DOCUMENT_GET: (documentCategory: string, transporterId: number) => `/document/get/${documentCategory}/${transporterId}`,
  DOCUMENT_EXIST: (documentCategory: string) => `/document/exist/${documentCategory}`,

  TRANSPORT: '/transport',
  TRANSPORT_ORDER: '/transport-order',
  TRANSPORT_TYPE: '/transport-type',
  TRANSPORT_TYPE_EMPTY: '/transport-type/empty',

  VEHICLE: '/vehicle',

  TRANSPORT_INCIDENTS: '/transport-incidents',
  TRANSPORT_INCIDENTS_ID: (transportId?: number) => `/transport-incidents/${transportId}`,
  TRANSPORT_INCIDENTS_TRANSPORT_ORDER_ID: (transportId?: number) => `/transport-incidents/transport-order/${transportId}`,
  TRANSPORT_INCIDENTS_TRANSPORTER_DECLARE: '/transport-incidents/transporter/declare',
  TRANSPORT_INCIDENTS_ESTIMATE: '/transport-incidents/estimate',
  TRANSPORT_INCIDENT_ITEMS: '/transport-incident-items',

  TRANSPORTER: '/transporter',

  DELIVERY_STEPS_TRANSPORT_ORDER: '/delivery-steps/transport-order',
  DELIVERY_STEPS_PODS: '/delivery-steps/pods/transport-order',

  UNVALIDATED_BASKETS: '/transport/pending',

  QUOTATION: '/quotation',
  QUOTATION_DENY: (transportId?: number) => `/quotation/deny/${transportId}`,
  QUOTATION_ACCEPT: (transportId?: number) => `/quotation/accept/${transportId}`,
  QUOTATION_RESET: (transportId?: number) => `/quotation/reset/${transportId}`,
  QUOTATION_STATS: '/quotation/stats',
  QUOTATION_RESPONSE_TIME: '/quotation/response-time',

  USER: '',
  USER_LOGIN: (login?: string) => `/${login}`,
  USER_DETAIL: '/detail',

  REGISTERED_ADDRESS: '/registered-address',
  REGISTERED_ADDRESS_ID: (registeredAddressId?: number) => `/registered-address/${registeredAddressId}`,

  CUSTOMER: '/customers',
  CUSTOMER_ID: (cId?: number) => `/customers/${cId}`,
  CUSTOMER_COUNT: '/customers/count',
  CUSTOMER_ID_USER: (cId?: number) => `/customers/${cId}/user`,
  CUSTOMER_CURRENT: () => `/customer/current`, // PUBLIC URL
  CUSTOMER_USER_ID_DELETE_ALIAS: (customerId?: number) => `/customers/${customerId}/user/deleteAlias`,
  CUSTOMER_DATA: '/customer/data',

  COOKIE_CONSENT: '/consent',
  COMMERCIAL: '/commercials',
  GROUP: '/groups',

  USER_DATA: '/user_data',

  ACCEPTANCES: '/acceptances',
  ACCEPTANCES_DOWNLOAD: '/acceptances/transporter/file/',
  ACCEPTANCES_DOWNLOAD_OFFER: (offerId: number) => `/acceptances/transporter/file/offer/${offerId}`,

  CUT_OFFS: '/cut-offs',
  CUT_OFFS_DOWNLOAD: '/cut-offs/transporter/file/',
  CUT_OFFS_DOWNLOAD_OFFER: (offerId: number) => `/cut-offs/transporter/file/offer/${offerId}`,

  MERCHANDISES: '/merchandises',
  INSURANCE: '/insurances',
  INSURANCE_ITEMS: '/insurance-items', // PUBLIC URL
  INSURANCE_ITEMS_ID: (insuranceItemId?: number) => `/insurance-items/${insuranceItemId}`, // PUBLIC URL
  INSURANCE_ITEMS_OFFER_ID: (offerId?: number) => `/insurance-items/offer/${offerId}`,
  INSURANCE_ITEMS_GLOBAL: () => `/insurance-items/global`,
  INSURANCE_ITEMS_GLOBALBYNAME: () => `/insurance-items/global-by-name`,

  HEADBANDS: '/headbands',
  SPECIAL_PLACE: '/special-place',

  OFFER: '/offer',
  OFFER_DEVIS: '/offer/devis',
  OFFER_EMPTY: '/offer/empty',
  OFFER_ID: (offerId?: number) => `/offer/${offerId}`,
  OFFER_CUSTOMER_ID: (offerId?: number) => `/offer/customer/${offerId}`,
  OFFER_ID_INSURANCE_ITEMS: (offerId?: number) => `/offer/${offerId}/insuranceItems`,
  OFFER_ID_DUPLICATE: (offerId?: number) => `/offer/${offerId}/duplicate`,

  FUEL_INDEXING: '/fuel-indexing',

  OFFER_HANDLING_TYPE: '/offer-handling-type',
  OFFER_VEHICLE: '/offer-vehicle',

  // ADMIN
  OFFER_TRANSPORTER_ID: (transporterId?: number) => `/offer/transporter/${transporterId}`,
  OFFER_TRANSPORTER_ID_VOLUPAL: (transporterId?: number) => `/offer/transporter/${transporterId}/volupal`,

  TRANSPORTER_CONFIGURATION(configType?: string, transporterId?: number) {
    // PUBLIC URL
    if (transporterId) {
      return `/transporter-configuration/${configType}/${transporterId}`;
    } else {
      return `/transporter-configuration/${configType}`;
    }
  },
  MODERATOR_TRANSPORTER_CONFIGURATION(configType?: string, transporterId?: number) {
    if (transporterId) {
      return `/transporter-configuration/${configType}/${transporterId}`;
    } else {
      return `/transporter-configuration/${configType}`;
    }
  },

  EDI_HISTORIES: '/edi',
  EDI_DOWNLOAD_FILE: (ediHistoryId?: number) => `/edi/file/${ediHistoryId}`,
  EDI_HISTORIES_TRANSPORT_ORDER_ID: (transportOrderId?: number) => `/edi/transport-order/${transportOrderId}`,

  SPECIAL_PLACE_LISTS_INIT_ID: (transporterId?: number) => `/special-place-lists/init/${transporterId}`,
  SPECIAL_PLACE_LISTS_COPY_ID: (transporterId?: number) => `/special-place-lists/copy/${transporterId}`,

  // ADMIN TOOLS
  TOOLS_RETRY_INCIDENT_PAYMENT: (transportIncidentId?: number) => `/transport-incidents/${transportIncidentId}/retryPayment`,
  TOOLS_DELETE_TRANSPORT_ORDERS: (transporterId?: number) => `/transport-order/transporter/${transporterId}`,
  TOOLS_CANCEL_TRANSPORT_ORDERS: (transporterId?: number) => `/transport-order/transporter/cancel/${transporterId}`,
  TOOLS_FORCED_PAYMENT_TRANSPORT_ORDERS: (transporterOrderId?: number) => `/transport-order/${transporterOrderId}/forcedPayment`,
  TOOLS_DELETE_CUSTOMERS: (transporterId?: number) => `/tools/transporter/${transporterId}/delete-users`,
  ADMIN_TRANSPORTER_UPDATE_DNS: (transporterId: number, domainName: string) => `/transporter/${transporterId}/updateDNS?domainName=${domainName}`,

  ADMIN_USER_MANAGEMENT: '/users',
  ADMIN_IMPERSONATE_MANAGEMENT: '/impersonate',

  // UPLOAD & DELETE
  DELETE_CUSTOMER_PRICING: (customerId: number, offerId: number) => `/delete/PRICING/CUSTOMER/${customerId}/offer/${offerId}`,

  REF_ADR: '/ref-adr',
  REF_ADR_UN: '/ref-adr/un-code',

  // Upload POD confirm Delivery
  CONFIRM_DELIVERY: (transportOrderId: number) => `/transport-order/${transportOrderId}/confirm-delivery`,

  ESTIMATE: '/estimate',
  TRANSPORT_CONFIGURATION: '/transport-configuration/options',
  DATE_URL: '/date',

  PAYMENT_STEP: '/paymentStep',
  PAYMENT_FORM: '/paymentForm',

  TRANSPORT_ORDER_ITEM: '/transport-order-item',

  SPECIAL_PLACE_PRICING_ITEMS: '/special-place-pricing-items',
  SPECIAL_PLACE_PRICING_ITEMS_ID: (specialPlacePricingItemId: number) => `/special-place-pricing-items/${specialPlacePricingItemId}`,
  REF_DIMENSION: '/ref-dimension',
};
